export default "__VITE_ASSET__BeBoQw9H__"